import produce from "immer"
import { ASC } from "const"
import { CcRequirementType } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcRequirementType: CcRequirementType = {
    id: null,
    accountId: null,
    projectId: null,
    name: "",
    description: "",
    creator: null,
    default: false,
}

const initCcRequirementTypeState: types.CcRequirementTypeState = {
    typeList: {},
    typeIds: [],
    typeEdit: initCcRequirementType,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const ccRequirementTypeReducer = produce((
    draft: types.CcRequirementTypeState = initCcRequirementTypeState,
    action: ActionTypes = null,
): types.CcRequirementTypeState => {
    switch (action.type) {
        case types.CC_REQUIREMENT_TYPE_LIST:
            draft.typeList = action.typeList
            return draft

        case types.CC_REQUIREMENT_TYPE_IDS:
            draft.typeIds = action.typeIds
            return draft

        case types.CC_REQUIREMENT_TYPE_EDIT:
            draft.typeEdit = action.value
            return draft

        case types.CC_REQUIREMENT_TYPE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.CC_REQUIREMENT_TYPE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.CC_REQUIREMENT_TYPE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_REQUIREMENT_TYPE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccRequirementTypeReducer
